import { render, staticRenderFns } from "./item-err-tip.vue?vue&type=template&id=6301f49d&scoped=true"
import script from "./item-err-tip.vue?vue&type=script&lang=js"
export * from "./item-err-tip.vue?vue&type=script&lang=js"
import style0 from "./item-err-tip.vue?vue&type=style&index=0&id=6301f49d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301f49d",
  null
  
)

export default component.exports